import { render } from "./CargoUnitForm.vue?vue&type=template&id=dbf8be66&scoped=true"
import script from "./CargoUnitForm.vue?vue&type=script&lang=js"
export * from "./CargoUnitForm.vue?vue&type=script&lang=js"

import "./CargoUnitForm.vue?vue&type=style&index=0&id=dbf8be66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbf8be66"]])

export default __exports__